
export const MEETUP_REQUESTED = 'EVENTJUICER/MEETUP_REQUESTED';